import { convertDate } from './dateUtils';

export const getDecoratedNotificationDetails = (data) => {
    if (data?.id) {
        // Ticket notification
        return {
            id: data?.id,
            alertType: data?.alertType,
            ticket: data?.ticketReferenceNumber,
            title: `${data?.title}`,
            start: data?.startDate,
            end: data?.endDate,
            description: data?.description
        };
    }
};

export const formatSchedule = (startDate, endDate) =>
    startDate && endDate ? `${convertDate(startDate, false, true)} until ${convertDate(endDate, false, true)}` : '';
